import { observable } from "mobx";
import IModelFormat from "../interfaces/IModelFormat";
import IMenuItem from "../interfaces/IMenuItem";

export default class ModelStore {

  @observable public headline: string ="";
  @observable public menu: IMenuItem[] = [];
  @observable public menuItems: IMenuItem[] = [];
  @observable public selectedMenu: IMenuItem | null = null;
  @observable public subMenu: any[] | null = null;

  @observable public selectedModel: IModelFormat | null = null;
  @observable public selectedInlay: any | null = null;
  @observable public selectedPrintColor: any | null = null;
  @observable public selectedRefinement: any | null = null;
  @observable public selectedPrintColors: string | null = null;
  @observable public selectedService: any | null = null;
  @observable public selectedRefinements: any | null = null;

  @observable public isLoading: boolean = true;
  @observable public selectedIndex: number = 0;

  @observable public sideBarText: string = "";


  @observable public services = [
    {
        "description": "Auch bei sehr anspruchsvollen Verpackungslösungen sorgen wir dafür, dass Sie sich nach der Konstruktion um nichts Weiteres kümmern müssen. So können Sie sich bedenkenlos ihrem Kerngeschäft widmen.",
        "title": "Sorgenfreie Abwicklung",
    },
    {
        "description": "Planen Sie den Einsatz von Verpackungsautomaten? Gerne beraten wir Sie vor der Anschaffung und konfigurieren ihre Verpackungen optimal. Das sichert Ihnen einen Prozess ohne Qualitätseinbußen, Störungen und Ausfälle.",
        "title": "Optimierung der Automation" },
    {
        "description": "Lagerung und Versandabwicklung in Ihrem Namen. Die von uns produzierten Verpackungen werden vorgehalten und in ihrem Auftrag mit ihren Dokumenten versendet. Ihre Kunden hat dabei mit uns keine Berührung und erhält die Ware als würde er von Ihnen beliefert. So gewinnen Sie Lagerfläche und höhere Flexibilität in der Logistik!",   
        "title": "Dropshipping"},
    {
        "description": "Benötigen Sie ihre Verpackungen an mehreren Standorten in unterschiedlichen Losgrößen, so liefern wir entsprechende Stückzahlen an mehrere Adressen.",
        "title": "Variable Lieferadressen"},
    {
       "description": "Wenn alles schief geht, sind wir da! Z. B. wenn der Lagerbestand versehentlich gegen Null läuft oder sehr eilig Messeexponate erforderlich sind.",
        "title": "„Wir boxen Dich raus“ - Service"}
  ]

  public selectedProduct: string | null = null; 
  public selectedExpressMethod: string | null = null;



  constructor() {
    this.loadModels();
  }

  // http://hoffmannundschelle.local:8888/
  // https://www.hoffmannundschelle.de/configurator.json
  public loadModels = () => {
    fetch(`https://www.hoffmannundschelle.de/configurator.json`, {
      method: "get"
    })
      .then(response => response.json())
      .then(data => {
        this.setModels(data);
      });
  };

  public setModels = (data: any) => {
    this.menu = data.data;
    this.showMenuItems();
    this.selectedMenu = this.menu[0];
    this.isLoading = false;
  };

  public start() {
    this.selectedModel = this.menu[1]!.products[0];
    this.setSelectedIndex(1);
    this.selectedMenu!.products[0].selected = true;
  }
  

  public setSelectedSubMenuItem(item: IModelFormat) {

    switch (this.selectedIndex) {
      case 1:
        this.highlightItem(this.selectedMenu!.products, item);
        this.selectedModel = item;
        this.selectedPrintColors = null;
        this.selectedInlay = null;
        this.selectedRefinement = null;
        break;
      case 2:
        this.highlightItem(this.selectedModel!.inlays, item);
        this.selectedInlay = item;
        break;
      case 3:
        this.highlightGroupItem(this.selectedModel!.printcolors, item);
        this.selectedPrintColors = this.collectSelectedTitles(this.selectedModel!.printcolors);
        break;
      case 4:
        // this.highlightItem(this.selectedModel!.refinements, item);
        item.selected = !item.selected
        this.selectedRefinement = item;
        this.selectedRefinements = this.collectSelectedTitles(this.selectedModel!.refinements);
        break;
      case 5:
        this.subMenu = null;
        break;
    }

    this.updateSideBarText();
  }

  public nextStep() {
    let newIndex = this.selectedIndex + 1 ;

    // skip inlays if none
    if(this.selectedIndex === 1 && this.selectedModel!.inlays.length===0){
        newIndex = newIndex + 1;
    }

    this.setSelectedIndex( newIndex );
  }
  public previousStep() {
    let newIndex = this.selectedIndex - 1 ;

    // skip inlays if none
    if(this.selectedIndex === 3 && this.selectedModel!.inlays.length===0){
      newIndex = newIndex - 1;
    }

    this.setSelectedIndex( newIndex );
  }
  public setSelectedIndex(p:number) {

    this.selectedIndex = p;

    switch (this.selectedIndex) {
      case 0:
        this.selectedMenu = this.menu[this.selectedIndex];
        this.subMenu = null;
      break;
      default:
        this.selectedMenu = this.menu[this.selectedIndex];
      break;
      case 6:
        this.selectedMenu = null
        break;
    }

    switch (this.selectedIndex) {
      case 0:
        this.headline = "";
      break;
      case 1:
        this.subMenu = this.menu[this.selectedIndex].products;
        this.headline = "Verpackungsform auswählen";
        break;
      case 2:
        this.subMenu = this.selectedModel!.inlays;
        this.headline = "Inlay auswählen (optional)";
        break;
      case 3:
        this.subMenu = this.selectedModel!.printcolors;
        this.headline = "Druck auswählen";
        break;
      case 4:
        this.subMenu = this.selectedModel!.refinements;
        this.headline = ""; // "Veredelung auswählen";
        break;
      case 5:
        this.subMenu = null;
        this.headline = "";
        break;
      case 6:
        this.selectedMenu = null
        this.headline = "";
        break;
    }

    this.showMenuItems();
    this.updateSideBarText();

    const renderer=document.querySelector(".sub-nav");
    if(renderer !== null){
      renderer.scrollLeft = 0;
    }

  }
  public setSelectedService(p:any){
    this.selectedService = p ;
    this.updateSideBarText();
  }

  private showMenuItems(){
    this.menuItems = [ ]
    for(let i=0;i<=Math.min(5,this.selectedIndex);i++){
      this.menu[i].index = i;
      if(i !== 2 ||  this.selectedModel!.inlays.length>0){
        this.menuItems.push(this.menu[i]);
      }
      
    }
  }

  private highlightItem(data: any[], item: any) {
    for (let i = 0; i <= data.length - 1; i++) {
      data[i].selected = data[i] === item;
    }
  }

  private highlightGroupItem(data: any[], item: any) {
    item.selected = !item.selected;
    for (let i = 0; i <= data.length - 1; i++) {
      if(data[i] !== item && data[i].group[0] === item.group[0]){
        data[i].selected=false;
      }
    }
  }
  private collectSelectedTitles(data: any[]): string {
    const titles:string[]  =[];
    for (let i = 0; i <= data.length - 1; i++) {
      if(data[i].selected){
        titles.push(data[i].title);
      }
    }
    return titles.join(",");
  }

  private updateSideBarText(){
    switch (this.selectedIndex) {
      case 0:
        this.sideBarText = "";
      break;
      case 1:
      case 3:
      case 2:
        if(this.selectedInlay!== null){
          this.sideBarText = this.formatInlayInfo();
        }else{
          this.sideBarText = this.formatProductInfo();
        }
        
      break;
      case 4:
        if(this.selectedRefinement!== null){
          this.sideBarText = this.formatRefinementInfo();
        }else{
          this.sideBarText = this.formatProductInfo();
        }
      break;
      case 5:
        if(this.selectedService!== null){
          this.sideBarText = this.formatServiceInfo();
        }else{
          this.sideBarText = this.formatProductInfo();
        }
      break;
    }
  }

  private formatProductInfo(): string {
    const snippets:string[]  =[];
    snippets.push('<h2>' + this.selectedModel!.title +'</h2>');
    snippets.push('<div>' + this.selectedModel!.shortdescription +'</div>');
    snippets.push('<h2>Einsatzmöglichkeiten</h2>');
    this.selectedModel!.markets.map( 
      (model: string , index: number )=>{
        snippets.push('<div className="feature">+&nbsp;'+ model + '</div>');
    }); 
    return snippets.join('');
  }
  private formatInlayInfo(): string {
    const snippets:string[]  =[];
    snippets.push('<h2>' + this.selectedInlay!.title +'</h2>');
    snippets.push('<div>' + this.selectedInlay!.description +'</div>');
    return snippets.join('');
  }
  private formatRefinementInfo(): string {
    const snippets:string[]  =[];
    snippets.push('<h2>' + this.selectedRefinement!.title +'</h2>');
    snippets.push('<div>' + this.selectedRefinement!.description +'</div>');
    return snippets.join('');
  }
  private formatServiceInfo(): string {
    const snippets:string[]  =[];
    snippets.push('<h2>' + this.selectedService!.title +'</h2>');
    snippets.push('<div>' + this.selectedService!.description +'</div>');
    return snippets.join('');
  }
  
}



// WEBPACK FOOTER //
// ./src/stores/ModelStore.tsx